<div *ngIf="modelConfiguration">
  <h5> {{ 'masterdetail.offerfee' | translate }} </h5>
  <ct-model [configuration]="modelConfiguration"></ct-model>
</div>


<ng-template #AmountCellTemplate let-row="row">

  <p>{{row.Amount}} {{row.AmountType === 2 ? '%' : '€'}}</p>

</ng-template>
